import { render, staticRenderFns } from "./PremiumInformation.vue?vue&type=template&id=65726da5&scoped=true&"
import script from "./PremiumInformation.vue?vue&type=script&lang=ts&"
export * from "./PremiumInformation.vue?vue&type=script&lang=ts&"
import style0 from "./PremiumInformation.vue?vue&type=style&index=0&id=65726da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65726da5",
  null
  
)

export default component.exports